import React from 'react'
import '../Components/css/PageTitle.min.css'
export default function PageTitle(props) {
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="page_title">
                    <h2 className="page_info">{props.Pageinfo}</h2>
                    <h5 className="page_name">{props.Pagename} <span>{props.Highlight}</span></h5>
                </div>
            </div>
        </div>

    )
}
